import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-cancel-button',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
  template: `
    <ng-container *ngIf="routerLink; else clickButton">
      <button mat-stroked-button color="warn" [routerLink]="routerLink"><mat-icon>close</mat-icon> {{ label }}</button>
    </ng-container>
    <ng-template #clickButton>
      <button mat-stroked-button color="warn" (click)="cancel.emit()"><mat-icon>close</mat-icon> {{ label }}</button>
    </ng-template>
  `
})
export class CancelButtonComponent {
  @Input() label = 'Cancelar'
  @Input() routerLink?: string
  @Output() cancel = new EventEmitter<void>()
}
